module.exports = __webpack_public_path__ + "img/hub-accounting-logo.4c28bcdf.webp";